export const PLAYER_EVENT = {
    PAUSE: 'pause',
    SEEKED: 'seeked',
    ENDED: 'ended',
    TIMEUPDATE: 'timeupdate',
    VOLUMECHANGE: 'volumechange',
    ERROR: 'error',
    FULLSCREENCHANGE: 'fullscreenchange',
    RESIZE: 'resize',
    PLAY: 'play',
    QUALITYCHANGE: 'qualitychange',
    LOADEDMETADATA: 'loadedmetadata',
    READY: 'ready',
};

export const QUALITY_EVENT = {
    CHANGE: 'change',
};

export const PLAYBACK_STATE = {
    IDLE: 'idle',
    PLAYING: 'playing',
    PAUSED: 'paused',
    ENDED: 'ended',
    BUFFERING: 'buffering',
    ERROR: 'error'
};

// Cross-window message types used between VodInformation (parent) and VideoPlayback (child)
export const MESSAGE_TYPE = {
    VIDEO_PLAYER_EVENT: 'VIDEO_PLAYER_EVENT',
    VIDEO_PLAYER_CLOSING: 'VIDEO_PLAYER_CLOSING',
};

// Window name for video player popup
export const VIDEO_PLAYER_WINDOW_NAME = 'keduall_vod_player';

// Lesson state for accordion items
export const LESSON_STATE = {
    IDLE: 'idle',
    LOADING: 'loading',
    SELECTED: 'selected',
    PLAYING: 'playing'
};